import { call, put } from 'redux-saga/effects';
import { apiRequest } from '../../../api/api.saga-services';
import * as meetingsApi from '../../../api/request-config/meeting.api';
import * as sessionsApi from '../../../api/request-config/session.api';
import * as pageActions from './meeting-archive.actions';
import * as resourceActions from '../../../resource/meeting-archives/meeting-archives.actions';
import { IMeetingSimple } from '../../../resource/meeting-simple/meeting-simple.types';
import { IQueryParams } from './meeting-archive.types';
import { IMeetingArchive } from '../../../resource/meeting-archives/meeting-archives.types';
import { ISession } from '../../../resource/session/session.types';
import { meetingArchiveSelectors } from '../../../resource/meeting-archives/meeting-archives.selectors';
import { meetingsArchivesPageSelectors } from './meeting-archive.selectors';
import { select, selectWithParams } from '../../../../utils/selector.utils';

export function* fetchMeetingArchive(archiveId: IMeetingArchive['id']) {
  const response = yield call(apiRequest, sessionsApi.getMeetingArchiveApi(archiveId));
  if (!response) {
    return;
  }
  yield put(resourceActions.storeMeetingArchive(response));
}

export function* fetchMeetingArchives(meetingId: IMeetingSimple['id'], searchParams: IQueryParams) {
  const response = (yield call(apiRequest, meetingsApi.getMeetingArchivesApi(meetingId, searchParams))) as {
    archives: IMeetingArchive[];
    currentPage: number;
    totalPages: number;
  };
  if (!response) {
    return;
  }

  yield put(resourceActions.storeMeetingArchive(response.archives));

  const archives = response.archives;

  const archivesIds = archives.map((archive) => archive.id);
  yield put(pageActions.storeMeetingArchivesIds(archivesIds));
  yield put(pageActions.storeMeetingArchiveCurrentPage(response.currentPage));
  yield put(pageActions.storeMeetingArchiveTotalPages(response.totalPages));
}

export function* upsertMeetingArchiveTranscriptFromSession(session: ISession) {
  if (!session.transcriptStatus) {
    return;
  }

  const existing = (yield selectWithParams(meetingArchiveSelectors.selectResourceById, session.id)) as
    | IMeetingArchive
    | undefined;

  yield put(
    resourceActions.storeMeetingArchive({
      ...existing,
      id: session.id,
      meetingDate: existing?.meetingDate ?? session.startedDate,
      transcriptStatus: session.transcriptStatus,
    } as IMeetingArchive),
  );

  const archiveIds = (yield select(meetingsArchivesPageSelectors.selectMeetingArchivesIds)) as IMeetingArchive['id'][];
  if (!archiveIds.includes(session.id)) {
    yield put(pageActions.storeMeetingArchivesIds([session.id, ...archiveIds]));
  }
}
